import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Category, CategoryAdapter } from '../Models/category';
import { Policy, PolicyAdapter } from '../Models/policy';
import { ApiRestService } from './api-rest.service';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  // categoryList : Category[];
  // policyList : Policy[];
  // policyList_filter : Policy[];

  constructor(private apiRestService: ApiRestService
    , private categoryAdapter: CategoryAdapter
    , private policyAdapter: PolicyAdapter) { }


  getPolicis(apiCall) {
    return this.apiRestService.getJasonRestApi(apiCall, 'Schoolboard Policy').pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category mapping');
      })
    );
  }

  addPolicy(apiCall, content) {
    return this.apiRestService.postJasonRestApi(apiCall, 'Schoolboard Policy', content).pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category post mapping')
      })
    );
  }
    
  updatePolicy(apiCall, content) {
    return this.apiRestService.postJasonRestApi(apiCall, 'Schoolboard Policy', content).pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category post mapping')
      })
    );
  }

  getCategoryPolicies(apiCall, categoryID) {
    return this.getPolicis(apiCall + categoryID);
  }

  getCurrentUserInfo(apiCall) {
    return this.apiRestService.getJasonRestApi(apiCall, 'Schoolboard Policy').pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category mapping');
      })
    );
  }
}
